import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import 'font-awesome/css/font-awesome.min.css';
import { Route, Switch } from 'react-router';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import ControlledRoute from '../../security/controlledRoute';
import { getEffectiveRoutes } from '../../security/route';
import NotFound from '../../shared/not-found/notFound';
import AccueilLayout from './layout/layout';
import { routes } from './route/routes';

const ROUTING_ANIMATION = 'fadeup';

const Accueil: React.FC = () => {
  return (
    <AccueilLayout>
      <TransitionGroup>
        <Switch>
          {getEffectiveRoutes(routes).map(({ path, Component, exact, roles }) => (
            // @ts-ignore
            <ControlledRoute key={path} exact={exact} path={`${process.env.PUBLIC_URL}${path}`} roles={roles}>
              <CSSTransition in={true} timeout={0} classNames={ROUTING_ANIMATION} unmountOnExit>
                <Component />
              </CSSTransition>
            </ControlledRoute>
          ))}
          <Route component={NotFound} />
        </Switch>
      </TransitionGroup>
    </AccueilLayout>
  );
};

export default Accueil;
